import "./src/styles/theme.css";
import "./src/styles/global.css";
import React from "react";
import { AuthProvider } from "./src/components/AuthProvider";

export const wrapRootElement = ({ element }: any) => {
  return <AuthProvider>{element}</AuthProvider>;
};
